/* tslint:disable */
/* eslint-disable */
/**
 * TOM ADMIN SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateIsoCodeMappingCommand } from '../model';
// @ts-ignore
import type { IsoCodeMappingResponseDto } from '../model';
// @ts-ignore
import type { UpdateIsoCodeMappingCommand } from '../model';
/**
 * IsoCodeMappingsApi - axios parameter creator
 */
export const IsoCodeMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsDelete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('isoCodeMappingsDelete', 'id', id)
            const localVarPath = `/admin/api/IsoCodeMappings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/IsoCodeMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsGetContainerCharacteristicsByIsoCode: async (isoCodes: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isoCodes' is not null or undefined
            assertParamExists('isoCodeMappingsGetContainerCharacteristicsByIsoCode', 'isoCodes', isoCodes)
            const localVarPath = `/admin/api/IsoCodeMappings/GetContainerCharacteristicsByIsoCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (isoCodes) {
                localVarQueryParameter['IsoCodes'] = isoCodes;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateIsoCodeMappingCommand} [createIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsPost: async (createIsoCodeMappingCommand?: CreateIsoCodeMappingCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/IsoCodeMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIsoCodeMappingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateIsoCodeMappingCommand} [updateIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsPut: async (updateIsoCodeMappingCommand?: UpdateIsoCodeMappingCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/api/IsoCodeMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateIsoCodeMappingCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IsoCodeMappingsApi - functional programming interface
 */
export const IsoCodeMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IsoCodeMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isoCodeMappingsDelete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isoCodeMappingsDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsoCodeMappingsApi.isoCodeMappingsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isoCodeMappingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IsoCodeMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isoCodeMappingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsoCodeMappingsApi.isoCodeMappingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IsoCodeMappingResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsoCodeMappingsApi.isoCodeMappingsGetContainerCharacteristicsByIsoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateIsoCodeMappingCommand} [createIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isoCodeMappingsPost(createIsoCodeMappingCommand?: CreateIsoCodeMappingCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isoCodeMappingsPost(createIsoCodeMappingCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsoCodeMappingsApi.isoCodeMappingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateIsoCodeMappingCommand} [updateIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isoCodeMappingsPut(updateIsoCodeMappingCommand?: UpdateIsoCodeMappingCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isoCodeMappingsPut(updateIsoCodeMappingCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IsoCodeMappingsApi.isoCodeMappingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IsoCodeMappingsApi - factory interface
 */
export const IsoCodeMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IsoCodeMappingsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsDelete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.isoCodeMappingsDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<IsoCodeMappingResponseDto>> {
            return localVarFp.isoCodeMappingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} isoCodes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<IsoCodeMappingResponseDto>> {
            return localVarFp.isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateIsoCodeMappingCommand} [createIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsPost(createIsoCodeMappingCommand?: CreateIsoCodeMappingCommand, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.isoCodeMappingsPost(createIsoCodeMappingCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateIsoCodeMappingCommand} [updateIsoCodeMappingCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isoCodeMappingsPut(updateIsoCodeMappingCommand?: UpdateIsoCodeMappingCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.isoCodeMappingsPut(updateIsoCodeMappingCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IsoCodeMappingsApi - object-oriented interface
 */
export class IsoCodeMappingsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isoCodeMappingsDelete(id: number, options?: RawAxiosRequestConfig) {
        return IsoCodeMappingsApiFp(this.configuration).isoCodeMappingsDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isoCodeMappingsGet(options?: RawAxiosRequestConfig) {
        return IsoCodeMappingsApiFp(this.configuration).isoCodeMappingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} isoCodes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes: Array<string>, options?: RawAxiosRequestConfig) {
        return IsoCodeMappingsApiFp(this.configuration).isoCodeMappingsGetContainerCharacteristicsByIsoCode(isoCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateIsoCodeMappingCommand} [createIsoCodeMappingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isoCodeMappingsPost(createIsoCodeMappingCommand?: CreateIsoCodeMappingCommand, options?: RawAxiosRequestConfig) {
        return IsoCodeMappingsApiFp(this.configuration).isoCodeMappingsPost(createIsoCodeMappingCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateIsoCodeMappingCommand} [updateIsoCodeMappingCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isoCodeMappingsPut(updateIsoCodeMappingCommand?: UpdateIsoCodeMappingCommand, options?: RawAxiosRequestConfig) {
        return IsoCodeMappingsApiFp(this.configuration).isoCodeMappingsPut(updateIsoCodeMappingCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

